module.exports = __webpack_public_path__ + "img/home-silder4.82080aef.png";